import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: 'print-page',
    imports: [RouterOutlet],
    templateUrl: './print-page.component.html'
})
export class PrintPageComponent {}